<swal #warnDateValidAlert
  title="Warning" i18n-title
  text="Invalid Date" i18n-text
  icon="warning"
  [swalOptions]="swalOptions">
</swal>
<swal #warnRentReviewDateValidAlert
  title="Warning" i18n-title
  text="Rent Review date should be between lease start and end date" i18n-text
  icon="warning"
  [swalOptions]="swalOptions">
</swal>
<swal #rentReviewDateAlert
  title="Warning" i18n-title
  text="Please enter lease start and end date before entering rent review date" i18n-text
  icon="warning"
  [swalOptions]="swalOptions">
</swal>

<form class="rent-review" [formGroup]="rentReviewForm" novalidate>
  <div class="formfields" fxLayout="row wrap">
    <div fxLayout="row" fxFlex="33">
      <div class="formfields__container" fxFlex="50">
        <mat-form-field>
          <label i18n>Space Type</label>
          <mat-select id="rent-review-space-type-{{index}}" formControlName="space_type"
            placeholder="Select One" i18n-placeholder floatPlaceholder="never">
            <mat-option *ngFor="let spaceType of spaceTypes" [value]="spaceType?.value">
              <span id="rent-review-space-type-{{spaceType?.value}}">{{ spaceType?.label }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="formfields__container" fxFlex="50">
        <mat-form-field floatLabel="never">
          <label i18n>Date</label>
          <input
            matInput
            id="rent-review-date-{{index}}"
            formControlName="review_date"
            [matDatepicker]="reviewDatepicker"
            [placeholder]="!rentReview.review_date && getUserCountry !== 'JPN' ? 'DD/MM/YYYY'
            : !rentReview.review_date && getUserCountry === 'JPN'? 'YYYY/MM/DD' : ''"
            (dateChange)="isValidDate($event)">
          <mat-datepicker-toggle matSuffix [for]="reviewDatepicker">
            <!-- <button type="button" class="input-icon"></button> -->
            <mat-icon>date_range</mat-icon>
          </mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #reviewDatepicker></mat-datepicker>
      </div>
    </div>
    
    <div fxLayout="row" fxFlex="33">
      <div class="formfields__container" fxFlex="50">
        <mat-form-field>
          <label><span i18n>Frequency</span> <span class="required">*</span></label>
          <mat-select id="rent-review-frequency-type-{{index}}" formControlName="frequency" placeholder="Select One" i18n-placeholder>
            <mat-option *ngFor="let frequency of rentFrequency" [value]="frequency?.value">
              <span id="rent-review-frequency-type-{{frequency?.value}}">{{ frequency?.label }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="formfields__container" fxFlex="50">
        <mat-form-field>
          <label><span i18n>Type</span> <span class="required">*</span></label>
          <mat-select id="rent-review-type-{{index}}" formControlName="type" placeholder="Select One" i18n-placeholder>
            <mat-option *ngFor="let type of rentType" [value]="type?.value">
              <span id="rent-review-type-{{type?.value}}">{{ type?.label }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxFlex="28">
      <div class="formfields__container" fxFlex="50" *ngIf="['Fixed'].includes(this.rentReviewForm.get('type').value)">
        <iv-currency-field
          label="Amount" i18n-label
          controlName="review_amount-{{index}}"
          [formControl]="rentReviewForm.get('review_amount')"
          [disabled]="disabled"
          [formFieldClass]="'unset-margin-label'"
        ></iv-currency-field>
      </div>
      <div class="formfields__container" fxFlex="50" *ngIf="['Fixed', 'CPI+'].includes(this.rentReviewForm.get('type').value)">
        <iv-decimal-field
          label="PCT %" i18n-label
          controlName="pct-{{index}}"
          [formControl]="rentReviewForm.get('pct')"
          [integerLimit]="3"
          [disabled]="disabled"
        ></iv-decimal-field>
      </div>
    </div>

    <div fxFlex="5" *ngIf="!disabled">
      <iv-delete [identifier]="rentReview.id" (deleteEvent)="deleteRentReview($event)"></iv-delete>
    </div>
  </div>

</form>
